import img1 from "../assets/gallery/India and Thailand/india-thailand1.jpg";
import img2 from "../assets/gallery/India and Thailand/india-thailand2.jpg";
import img3 from "../assets/gallery/India and Thailand/india-thailand3.jpg";
import img4 from "../assets/gallery/India and Thailand/india-thailand4.jpg";
import img5 from "../assets/gallery/India and Thailand/india-thailand5.jpg";
import img6 from "../assets/gallery/India and Thailand/india-thailand6.jpg";
import img7 from "../assets/gallery/India and Thailand/india-thailand7.jpg";
import img8 from "../assets/gallery/India and Thailand/india-thailand8.jpg";
import img9 from "../assets/gallery/India and Thailand/india-thailand9.jpg";
import img10 from "../assets/gallery/India and Thailand/india-thailand10.jpg";
import img11 from "../assets/gallery/India and Thailand/india-thailand11.jpg";
import img12 from "../assets/gallery/India and Thailand/india-thailand12.jpg";
import img13 from "../assets/gallery/India and Thailand/india-thailand13.jpg";
import img14 from "../assets/gallery/India and Thailand/india-thailand14.jpg";
import img15 from "../assets/gallery/India and Thailand/india-thailand15.jpg";
import img16 from "../assets/gallery/India and Thailand/india-thailand16.jpg";
import img17 from "../assets/gallery/India and Thailand/india-thailand17.jpg";
import img18 from "../assets/gallery/India and Thailand/india-thailand18.jpg";
import img19 from "../assets/gallery/India and Thailand/india-thailand19.jpg";
import img20 from "../assets/gallery/India and Thailand/india-thailand20.jpg";
import img21 from "../assets/gallery/India and Thailand/india-thailand21.jpg";
import img22 from "../assets/gallery/India and Thailand/india-thailand22.jpg";
import img23 from "../assets/gallery/India and Thailand/india-thailand23.jpg";
import img24 from "../assets/gallery/India and Thailand/india-thailand24.jpg";
import img25 from "../assets/gallery/India and Thailand/india-thailand25.jpg";
import img26 from "../assets/gallery/India and Thailand/india-thailand26.jpg";
import img27 from "../assets/gallery/India and Thailand/india-thailand27.jpg";
import img28 from "../assets/gallery/India and Thailand/india-thailand28.jpg";
import img29 from "../assets/gallery/India and Thailand/india-thailand29.jpg";
import img30 from "../assets/gallery/India and Thailand/india-thailand30.jpg";
import img31 from "../assets/gallery/India and Thailand/india-thailand31.jpg";
import img32 from "../assets/gallery/India and Thailand/india-thailand32.jpg";
import img33 from "../assets/gallery/India and Thailand/india-thailand33.jpg";
import img34 from "../assets/gallery/India and Thailand/india-thailand34.jpg";
import img35 from "../assets/gallery/India and Thailand/india-thailand35.jpg";

const indiaThailandGallery = [
  { img: img1, rowSpan: 2 },
  { img: img2 },
  { img: img3 },

  { img: img4 },
  { img: img5 },
  { img: img6, rowSpan: 2 },

  { img: img7, colSpan: 2 },

  { img: img8 },
  { img: img9, rowSpan: 2 },
  { img: img10 },

  { img: img11 },
  { img: img12 },
  { img: img13 },

  { img: img14, colSpan: 2 },
  { img: img15 },

  { img: img16 },
  { img: img17, rowSpan: 2 },
  { img: img18 },

  { img: img19, colSpan: 2 },

  { img: img20 },
  { img: img21 },
  { img: img22 },

  { img: img23, rowSpan: 2 },
  { img: img24 },
  { img: img25 },

  { img: img26, colSpan: 2 },
  { img: img27 },

  { img: img28 },
  { img: img29, rowSpan: 2 },
  { img: img30 },

  { img: img31 },
  { img: img32 },
  { img: img33 },

  { img: img34, colSpan: 2 },
  { img: img35 },
];

export default indiaThailandGallery;
